import type { ReactElement } from 'react';
import type { ExtensionRiskEstimate } from '@kirin/api-client/contracts/extensions';
import { marketplaceLabel } from './agentmesh-risk-labels';

interface MarketplaceCellProps {
  riskEstimate: ExtensionRiskEstimate | null | undefined;
}

/**
 * Inventory Extensions "Marketplace" column (KIR-5361): the marketplace of
 * the AgentMesh record behind the row's Risk value. AgentMesh can hold the
 * same version in several marketplaces; Kirin uses the one with the worst
 * verdict, then the fuller scan.
 * A dash when there is no assessment, or AgentMesh did not say which
 * marketplace it is from.
 */
export function MarketplaceCell({
  riskEstimate,
}: MarketplaceCellProps): ReactElement {
  const label = marketplaceLabel(riskEstimate?.marketplace);
  if (!label) {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <span className="block truncate" title={label}>
      {label}
    </span>
  );
}

MarketplaceCell.displayName = 'MarketplaceCell';
